import { render, staticRenderFns } from "./HallDetails.vue?vue&type=template&id=6f90c0a2&"
import script from "./HallDetails.vue?vue&type=script&lang=js&"
export * from "./HallDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports